<template>
        <el-form ref="tkForm" :model="tkForm">
    <div class="tkTd">
            <tr height="20" style='height:30.00pt;'>
            </tr>
            <tr height="27" style='height:20.25pt;'>
                <td class="tk65" height="27" width="960" colspan="11"
                    style='height:20.25pt;width:720.00pt;border-right:none;border-bottom:none;' x:str>
                </td>
            </tr>
            <!-- <tr height="27" style='height:20.25pt;'>
                <td class="tk65" height="27" colspan="11" style='height:20.25pt;border-right:none;border-bottom:none;'
                    x:str></td>
            </tr> -->
            <tr height="27" style='height:20.25pt;'>
                <td class="tk65" height="27" colspan="11" style='height:20.25pt;border-right:none;border-bottom:none;'
                    x:str>教师教学质量听课评价表</td>
            </tr>
            <tr height="26.67" style='height:20.00pt;mso-height-source:userset;mso-height-alt:400;'>
                <td class="tk67" height="26.67" colspan="5" style='height:20.00pt;border-right:none;border-bottom:none;'
                    x:str>
                    <el-form-item label="" prop="semester">
                        {{getSemesterName()}}
                    </el-form-item>
                </td>


                <td class="tk68" colspan="7" style='border-right:none;border-bottom:none;' x:str>
                    <div>
                        <el-form-item label="" style="text-align: left;" prop="teaType"
                            :rules="[{required: true, message: '请选择教师类型'}]">
                            <el-radio-group v-model="tkForm.teaType">
                                <el-radio label="专任教师">专任教师</el-radio>
                                <el-radio label="兼职教师">兼职教师</el-radio>
                                <el-radio label="外聘教师">外聘教师</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                </td>
            </tr>
            <tr height="5.67" style='height:5.00pt;'>

            </tr>
            <tr height="26.67" style='height:20.00pt;mso-height-source:userset;mso-height-alt:400;'>
                <td class="tk69" height="26.67" colspan="2"
                    style='height:20.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;width: 12%;'
                    x:str>
                    教师姓名</td>
                <td class="tk70" x:str>
                    <el-form-item label="" prop="teaCode" :rules="[{required: true, message: ' '}]">
                        <el-select v-model="tkForm.teaCode" placeholder="请选择" style="width: 150px;"
                            @change="tkTeaChange" filterable clearable>
                            <el-option v-for="(item, index) in tkComboData.teaName" :key="item.comboValue"
                                :value="item.comboValue" :label="item.comboName">
                            </el-option>
                        </el-select>
                    </el-form-item>

                </td>
                <td class="tk71" rowspan="2"
                    style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;width: 12%' x:str>课程名称
                </td>
                <td class="tk70" rowspan="2"
                    style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
                    <el-form-item label="" prop="courseCode" :rules="[{required: true, message: ' '}]">
                        <el-select v-model="tkForm.courseCode" placeholder="请选择" style="width: 150px;"
                            @change="tkCourseChange" clearable>
                            <el-option v-for="(item, index) in tkComboData.course" :key="item.comboValue"
                                :value="item.comboValue" :label="item.comboName">
                                <div slot>{{ item.className + " - (" + item.comboName + ")" }}</div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                </td>
                <td class="tk69" rowspan="2"
                    style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;width: 12%' x:str>课程类型
                </td>
                <td class="tk72" colspan="5" rowspan="2"
                    style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;text-align: center;'
                    x:str>
                    <el-form-item label="" prop="courseType" style="text-align: left;"
                        :rules="[{required: true, message: '请选择课程类型'}]">
                        <el-radio-group v-model="tkForm.courseType">
                            <el-radio label="理论">理论</el-radio><br />
                            <el-radio label="实践">实践</el-radio><br />
                            <el-radio label="理实一体">理实一体</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </td>
            </tr>
            <tr height="26.67" style='height:20.00pt;mso-height-source:userset;mso-height-alt:400;'>
                <td class="tk69" height="26.67" colspan="2"
                    style='height:20.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;'
                    x:str>
                    教师所在系部</td>
                <td class="tk70" style="height: 60px;" x:str>{{tkForm.szxbName}}</td>
            </tr>
            <tr height="53.33" style='height:40.00pt;mso-height-source:userset;mso-height-alt:800;'>
                <td class="tk69" height="53.33" colspan="2"
                    style='height:40.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;'
                    x:str>
                    听课班级</td>
                <td class="tk70" x:str>
                    {{tkForm.tkbjName}}
                </td>
                <td class="tk71" x:str>听课地点</td>
                <td class="tk70" x:str>
                    <el-form-item label="" prop="tkdd" :rules="[{required: true, message: ' '}]">
                        <el-select v-model="tkForm.tkdd" filterable placeholder="请选择" style="width: 150px;" clearable>
                            <el-option v-for="(item, index) in tkComboData.tkdd" :key="item.comboValue"
                                :value="item.comboValue" :label="item.comboName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </td>
                <td class="tk75" x:str>听课时间<br />(日期节次)</td>
                <td class="tk70" colspan="5"
                    style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
                    <el-form-item label="" prop="sj" :rules="[{required: true, message: ' '}]">
                        <el-date-picker v-model="tkForm.sj" type="date" style="width:200px;" placeholder="选择日期"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>

                    <el-form-item style="margin-top: -18px;" label="" prop="jc"
                        :rules="[{required: true, message: ' '}]">
                        <el-select v-model="tkForm.jc" placeholder="请选择" multiple
                            style="width:200px;" clearable>
                            <el-option v-for="(item, index) in tkComboData.jc" :key="item.comboValue"
                                :value="item.comboValue" :label="item.comboName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </td>
            </tr>
            <tr height="53.33" style='height:40.00pt;mso-height-source:userset;mso-height-alt:800;'>
                <td class="tk69" height="53.33" colspan="2"
                    style='height:40.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;'
                    x:str>
                    应到学生数</td>
                <td class="tk70" x:str>{{tkForm.ydxss}}</td>
                <td class="tk71" x:str>实到学生数</td>
                <td class="tk70" x:str>
                    <el-form-item label="" prop="sdxss">
                        <el-input-number v-model="tkForm.sdxss" style="width: 150px;" :min="0">
                        </el-input-number>
                    </el-form-item>
                </td>
                <td class="tk76" x:str>迟到学生数</td>
                <td class="tk70" colspan="5"
                    style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
                    <el-form-item label="" prop="cdxss">
                        <el-input-number v-model="tkForm.cdxss" style="width: 150px;" :min="0">
                        </el-input-number>
                    </el-form-item>
                </td>
            </tr>
            <tr height="19" style='height:14.25pt;'>
                <td class="tk69" height="38" rowspan="2"
                    style='height:28.50pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;'
                    x:str>
                    评价项目</td>
                <td class="tk69" colspan="5" rowspan="2"
                    style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>评价指标
                </td>
                <td class="tk69" colspan="4"
                    style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>评分标准
                </td>
                <td class="tk69" x:str>得分</td>
            </tr>
            <tr height="19" style='height:14.25pt;'>
                <td class="tk69" x:str>优</td>
                <td class="tk69" x:str>良</td>
                <td class="tk69" x:str>中</td>
                <td class="tk69" x:str>差</td>
                <td class="tk83"></td>
            </tr>

            <template v-for="(item,index) in pjxData">
                <tr height="57" style='height:42.75pt;'>
                    <td class="tk75" height="57" style='height:42.75pt;' x:str>
                        {{item.pjxmc}}<br />({{item.qz}}分)
                    </td>
                    <td class="tk77" colspan="5"
                        style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>
                        {{item.pjxnr}}
                    </td>
                    <td class="tk75" x:str>
                        <div v-html="item.y" />
                    </td>
                    <td class="tk75" x:str>
                        <div v-html="item.l" />
                    </td>
                    <td class="tk75" x:str>
                        <div v-html="item.z" />
                    </td>
                    <td class="tk83" x:str>
                        <div v-html="item.c" />
                    </td>

                    <td class="tk84" x:str>
                        <el-form-item label="" :prop="'dfArr['+index+']'" :rules="[{required: true, message: ' '}]">
                            <el-input-number @input="tkChangeDf($event,pjxData[index].bh)" v-model="tkForm.dfArr[index]"
                                style="width: 90px;" size="mini" :min="0" :max="parseInt(pjxData[index].qz)">
                            </el-input-number>
                        </el-form-item>
                    </td>
                </tr>
            </template>

            <tr height="26.67" style='height:20.00pt;mso-height-source:userset;mso-height-alt:400;'>
                <td class="tk78" height="26.67" colspan="10"
                    style='height:20.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;'
                    x:str>
                    合<span style='mso-spacerun:yes;'>&nbsp;&nbsp; </span>计</td>
                <td class="tk83">{{hjdf}}</td>
            </tr>
            <tr height="19" style='height:14.25pt;'>
                <td class="tk77" height="38" colspan="11" rowspan="2" style='border-bottom:none;height: 500px;' x:str>
                    综合评价与建议:
                    <el-form-item label="" prop="zhpjjy">
                        <el-input type="textarea" :rows="21" v-model="tkForm.zhpjjy" maxlength="500" show-word-limit>
                        </el-input>
                    </el-form-item>
                </td>
            </tr>
            <tr height="19" style='height:14.25pt;' />
            <tr height="19" style='height:14.25pt;'>
                <td class="tk80" height="19" style='height:14.25pt;'></td>
                <td colspan="4" style='mso-ignore:colspan;'></td>
                <td x:str>评价人:</td>
                <td class="tk85" colspan="5" style='border-bottom:none;' x:str>
                    {{userName}}
                </td>
            </tr>
            <tr height="19" style='height:14.25pt;'>
                <td class="tk81" height="19" style='height:14.25pt;'></td>
                <td class="tk82" colspan="4" style='mso-ignore:colspan;'></td>
                <td class="tk82" x:str>日<span style='mso-spacerun:yes;'>&nbsp; </span>期:</td>
                <td class="tk87" colspan="5" style='border-bottom:.5pt solid windowtext;' x:str>
                    <el-form-item label="" prop="rq" :rules="[{required: true, message: ' '}]">
                        <el-date-picker v-model="tkForm.rq" type="date" placeholder="选择日期" style="width: 100%;"
                            value-format="yyyy-MM-dd hh:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                </td>
            </tr>

            <tr height="57" style='height:42.75pt;mso-tkrowspan:3;'>
                <td height="57" colspan="11" style='height:42.75pt;mso-ignore:colspan;'></td>
            </tr>
            <tr height="19" style='height:14.25pt;'>
                <td class="tk89" height="19" colspan="11" style='height: 500px;' x:str>
                    教学过程组织和主要内容:<br />
                    <el-form-item label="" prop="jxgcnr">
                        <el-input type="textarea" :rows="25" v-model="tkForm.jxgcnr" maxlength="500" show-word-limit>
                        </el-input>
                    </el-form-item>
                </td>
            </tr>

            <tr height="20" style='height:30.00pt;'>
            </tr>
    </div>
        </el-form>
</template>

<script>
    import {confirmMsg, showNotify} from "utils/message";

    export default {
        props: ['userCode', 'userName', 'semesterCode', 'type', 'semesterCombo'],
        data() {
            return {
                tkForm: {
                    semester: '',
                    teaType: '',
                    teaCode: '',
                    teaName: '',
                    courseName: '',
                    courseCode: '',
                    courseType: '',
                    szxbCode: '',
                    szxbName: '',
                    tkbjName: '',
                    tkbjCode: '',
                    tkdd: '',
                    tksj: '',
                    ydxss: '',
                    sdxss: '',
                    cdxss: '',
                    zhpjjy: '',
                    jxgcnr: '',
                    df: new Map(),
                    dfArr: [],
                    rq: this.rqFormat(new Date()),
                    sj: this.format(new Date()),
                    jc: [],
                },

                //下拉框:
                tkComboData: {
                    //教师姓名
                    teaName: [],
                    //课程名称
                    course: [],
                    //听课班级
                    tkbj: [],
                    //听课地点
                    tkdd: [],
                    //节次
                    jc: []
                },
                //评价项
                pjxData: [],
                //得分数组
                dfArr: [],
                //合计得分
                hjdf: '',
                loadingMask:null
            };

        },
        mounted() {
            this.tkTeaCombo();
            this.tkTkddCombo();
            this.tkJcInfo();
            this.getPjxData()
        },
        methods: {
            showLoadingMask(str) {
                this.loadingMask = this.$loading({
                    lock: true,
                    text: str,
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.8)",
                });
            },
            /**关闭loading**/
            closeLoadingMask() {
                if (this.loadingMask) this.loadingMask.close();
            },
            /*教师教学质量听课评价表 start*/
            getSemesterName() {
                let ind = this.semesterCombo.findIndex(item => {
                    return item.comboValue == this.semesterCode
                })
                return this.semesterCombo[ind].comboName
            },

            rqFormat(dat) {
                //获取年月日，时间
                var year = dat.getFullYear();
                var mon = (dat.getMonth() + 1) < 10 ? "0" + (dat.getMonth() + 1) : dat.getMonth() + 1;
                var day = dat.getDate() < 10 ? "0" + (dat.getDate()) : dat.getDate();
                var hour = dat.getHours() < 10 ? "0" + (dat.getHours()) : dat.getHours();
                var min = dat.getMinutes() < 10 ? "0" + (dat.getMinutes()) : dat.getMinutes();
                var seon = dat.getSeconds() < 10 ? "0" + (dat.getSeconds()) : dat.getSeconds();

                var newDate = year + "-" + mon + "-" + day + " " + hour + ":" + min + ":" + seon;
                return newDate;
            },

            format(dat) {
                //获取年月日，时间
                var year = dat.getFullYear();
                var mon = (dat.getMonth() + 1) < 10 ? "0" + (dat.getMonth() + 1) : dat.getMonth() + 1;
                var day = dat.getDate() < 10 ? "0" + (dat.getDate()) : dat.getDate();

                var newDate = year + "-" + mon + "-" + day;
                return newDate;
            },
            tkChangeDf(event, index) {
                this.tkForm.df.set(index, event);
                this.hjdf = 0
                for (var i = 0; i < this.dfArr.length; i++) {
                    if (this.tkForm.df.get(this.dfArr[i]) !== undefined) {
                        this.hjdf += parseInt(this.tkForm.df.get(this.dfArr[i]))
                    }
                }
            },
            //提交听课评价表
            submit() {
                this.$refs['tkForm'].validate((valid) => {
                    if (valid) {
                        confirmMsg('提交后无法修改,是否确定提交?').then(() => {
                            this.showLoadingMask('提交中，请稍候...')
                            for (var i = 0; i < this.tkComboData.course.length; i++) {
                                if (this.tkComboData.course[i].comboValue === this.tkForm.courseCode) {
                                    this.tkForm.courseName = this.tkComboData.course[i].courseName
                                    break;
                                }
                            }

                            for (var i = 0; i < this.tkComboData.course.length; i++) {
                                if (this.tkComboData.course[i].comboValue === this.tkForm.courseCode) {
                                    this.tkForm.courseCode = this.tkComboData.course[i].otherInfo
                                    break;
                                }
                            }

                            for (var i = 0; i < this.tkComboData.teaName.length; i++) {
                                if (this.tkComboData.teaName[i].comboValue === this.tkForm.teaCode) {
                                    this.tkForm.teaName = this.tkComboData.teaName[i].comboName
                                    break;
                                }
                            }

                            const paramMap = {
                                'DF': this.tkForm.df,
                                'JSBH': this.tkForm.teaCode,
                                'JSXM': this.tkForm.teaName,
                                'JSLX': this.tkForm.teaType,
                                'JSXBDM': this.tkForm.szxbCode,
                                'JSXBMC': this.tkForm.szxbName,
                                'KCDM': this.tkForm.courseCode,
                                'KCMC': this.tkForm.courseName,
                                'TKKCLX': this.tkForm.courseType,
                                'TKBJBH': this.tkForm.tkbjCode,
                                'TKBJMC': this.tkForm.tkbjName,
                                'TKDD': this.tkForm.tkdd,
                                'TKRQ': this.tkForm.sj,
                                'TKJC': this.tkForm.jc.join(','),
                                'YDXSS': this.tkForm.ydxss,
                                'SDXSS': this.tkForm.sdxss,
                                'CDXSS': this.tkForm.cdxss,
                                'ZHPJJY': this.tkForm.zhpjjy,
                                'JXNRGC': this.tkForm.jxgcnr,
                                'RQ': this.tkForm.rq,

                                'CJR': this.userCode,
                                'type': this.type,
                                'semesterCode': this.semesterCode,
                            }

                            this.$api.evaluateManage.questionnaireServer.subTkForm({
                                    data: paramMap
                                })
                                .then((res) => {
                                    let state = res.data.data;
                                    switch (state) {
                                        case 'Success':
                                            // showNotify('成功', '提交成功', 'success', 1500);
                                            location.reload();
                                            break;
                                        default:
                                            this.closeLoadingMask()
                                            showNotify('错误', '提交失败', 'error', 3000);
                                            break;
                                    }
                                }).catch((err) => {
                                this.closeLoadingMask()
                                    console.log(err);
                                });
                        });

                    } else {
                        return false;
                    }
                });
            },
            //获取评价项内容
            getPjxData() {
                this.$api.evaluateManage.questionnaireServer.pjxData({
                        data: this.type
                    })
                    .then((res) => {
                        var map = new Map();
                        this.pjxData = res.data.data
                        for (var i = 0; i < this.pjxData.length; i++) {
                            this.tkForm.df.set(this.pjxData[i].bh, "");
                            this.dfArr.push(this.pjxData[i].bh)
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
            },
            querySearchTea(queryString, cb) {
                let teaName = this.tkComboData.teaName;
                let results = queryString ? teaName.filter(this.createFilter(queryString)) : teaName;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            querySearchTkdd(queryString, cb) {
                let tkdd = this.tkComboData.tkdd;
                let results = queryString ? tkdd.filter(this.createFilter(queryString)) : tkdd;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (results) => {
                    return (results.comboName.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
                };
            },

            //教师下拉框
            tkTeaCombo() {
                this.$api.evaluateManage.questionnaireServer.tkTeaCombo({
                    data:this.semesterCode
                })
                    .then((res) => {
                        this.tkComboData.teaName = res.data.data;
                    }).catch((err) => {
                        console.log(err);
                    });
            },
            //课程下拉框
            tkCourseCombo(paramMap) {
                this.$api.evaluateManage.questionnaireServer.tkCourseCombo({
                        data: paramMap
                    })
                    .then((res) => {
                        this.tkComboData.course = res.data.data;
                    }).catch((err) => {
                        console.log(err);
                    });
            },
            //填充教师所在系部
            tkSzxb(paramMap) {
                this.$api.evaluateManage.questionnaireServer.tkSzxb({
                        data: paramMap
                    })
                    .then((res) => {
                        this.tkForm.szxbName = res.data.data.comboName;
                        this.tkForm.szxbCode = res.data.data.comboValue;
                    }).catch((err) => {
                        console.log(err);
                    });
            },
            //更换教师
            tkTeaChange() {
                this.tkComboData.course = [];
                this.tkForm.courseName = "";
                this.tkForm.courseCode = "";
                this.tkForm.tkbjCode = "";
                this.tkForm.tkbjName = "";
                this.tkForm.szxbName = "";
                this.tkForm.szxbCode = "";
                const paramMap = {
                    'teaCode': this.tkForm.teaCode,
                    // 'teaCode': '109011',
                    'semesterCode': this.semesterCode,
                }
                if (this.tkForm.teaCode != "") {
                    this.tkCourseCombo(paramMap);
                    this.tkSzxb(paramMap)
                }
            },
            //更换课程
            tkCourseChange(str) {
                this.tkComboData.course.forEach(item=>{
                    if(item.comboValue === str){
                        this.tkForm.tkbjName = item.className;
                        this.tkForm.tkbjCode = item.classCode;
                        this.tkChangeTkbj()
                        return;
                    }
                })
            },
            //更换班级
            tkChangeTkbj() {
                const paramMap = {
                    'tkbjCode': this.tkForm.tkbjCode,
                    'semesterCode': this.semesterCode,
                    'skjhmxbh': this.tkForm.courseCode
                }
                this.$api.evaluateManage.questionnaireServer.tkYdxss({
                        data: paramMap
                    })
                    .then((res) => {
                        this.tkForm.ydxss = res.data.data
                    }).catch((err) => {
                        console.log(err);
                    });
            },
            //听课地点下拉框
            tkTkddCombo() {
                this.$api.evaluateManage.questionnaireServer.tkTkddCombo({})
                    .then((res) => {
                        this.tkComboData.tkdd = res.data.data
                    }).catch((err) => {
                        console.log(err);
                    });
            },
            //获得节次信息
            tkJcInfo() {
                this.tkForm.semester = this.semesterCode
                this.$api.evaluateManage.questionnaireServer.tkJcInfo({
                        data: this.tkForm.semester
                    })
                    .then((res) => {
                        this.tkComboData.jc = res.data.data
                    }).catch((err) => {
                        console.log(err);
                    });
            },
            /*教师教学质量听课评价表 end*/
        }
    }
</script>
<style>
    /* 教师教学质量听课评价表 start*/
    .styleTk {
        mso-number-format: "General";
        text-align: general;
        vertical-align: middle;
        white-space: nowrap;
        mso-rotate: 0;
        mso-pattern: auto;
        mso-background-source: auto;
        color: windowtext;
        font-size: 12.0pt;
        font-weight: 400;
        font-style: normal;
        text-decoration: none;
        font-family: 宋体;
        mso-generic-font-family: auto;
        mso-font-charset: 134;
        border: none;
        mso-protection: locked visible;
        mso-style-name: "常规";
        mso-style-id: 0;
    }

    .tkTd {
        mso-style-parent: styleTk;
        padding-top: 1px;
        padding-right: 1px;
        padding-left: 1px;
        mso-ignore: padding;
        mso-number-format: "General";
        text-align: general;
        vertical-align: middle;
        white-space: nowrap;
        mso-rotate: 0;
        mso-pattern: auto;
        mso-background-source: auto;
        color: windowtext;
        font-size: 12.0pt;
        font-weight: 400;
        font-style: normal;
        text-decoration: none;
        font-family: 宋体;
        mso-generic-font-family: auto;
        mso-font-charset: 134;
        border: none;
        mso-protection: locked visible;
    }

    .tk65 {
        mso-style-parent: styleTk;
        text-align: center;
        font-size: 16.0pt;
        font-weight: 700;
        mso-font-charset: 134;
    }

    .tk66 {
        mso-style-parent: styleTk;
        text-align: center;
        font-size: 16.0pt;
        font-weight: 700;
        mso-font-charset: 134;
    }

    .tk67 {
        mso-style-parent: styleTk;
        text-align: left;
        vertical-align: top;
        mso-font-charset: 134;
    }

    .tk68 {
        mso-style-parent: styleTk;
        text-align: center;
        mso-font-charset: 134;
    }

    .tk69 {
        mso-style-parent: styleTk;
        text-align: center;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
    }

    .tk70 {
        mso-style-parent: styleTk;
        text-align: center;
        font-size: 10.0pt;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
    }

    .tk71 {
        mso-style-parent: styleTk;
        text-align: center;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
    }

    .tk72 {
        mso-style-parent: styleTk;
        text-align: left;
        white-space: normal;
        font-size: 10.0pt;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
    }

    .tk73 {
        mso-style-parent: styleTk;
        text-align: left;
        white-space: normal;
        font-size: 10.0pt;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
    }

    .tk74 {
        mso-style-parent: styleTk;
        text-align: center;
        font-size: 10.0pt;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
    }

    .tk75 {
        mso-style-parent: styleTk;
        text-align: center;
        white-space: normal;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
    }

    .tk76 {
        mso-style-parent: styleTk;
        white-space: normal;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
    }

    .tk77 {
        mso-style-parent: styleTk;
        text-align: left;
        vertical-align: top;
        white-space: normal;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
    }

    .tk78 {
        mso-style-parent: styleTk;
        text-align: left;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
    }

    .tk79 {
        mso-style-parent: styleTk;
        text-align: left;
        vertical-align: top;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: .5pt solid windowtext;
    }

    .tk80 {
        mso-style-parent: styleTk;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
    }

    .tk81 {
        mso-style-parent: styleTk;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-bottom: .5pt solid windowtext;
    }

    .tk82 {
        mso-style-parent: styleTk;
        mso-font-charset: 134;
        border-bottom: .5pt solid windowtext;
    }

    .tk83 {
        mso-style-parent: styleTk;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
    }

    .tk84 {
        mso-style-parent: styleTk;
        text-align: center;
        font-size: 10.0pt;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
    }

    .tk85 {
        mso-style-parent: styleTk;
        mso-font-charset: 134;
        border-right: .5pt solid windowtext;
    }

    .tk86 {
        mso-style-parent: styleTk;
        mso-font-charset: 134;
        border-right: .5pt solid windowtext;
        border-bottom: .5pt solid windowtext;
    }

    .tk87 {
        mso-style-parent: styleTk;
        mso-font-charset: 134;
        border-right: .5pt solid windowtext;
        border-bottom: .5pt solid windowtext;
    }

    .tk88 {
        mso-style-parent: styleTk;
        text-align: center;
        mso-font-charset: 134;
        border-bottom: .5pt solid windowtext;
    }


    .tk89 {
        mso-style-parent: styleTk;
        text-align: left;
        vertical-align: top;
        white-space: normal;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
    }

    /* 教师教学质量听课评价表 end*/
</style>



// WEBPACK FOOTER //
// tkEvaluate.vue?56366fb8